
    <!--
 * 横版-页面导航
 * @LastEditTime: Mon Mar 31 2025 17:10:42 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_H25469"  v-show="compData.isShow" :class="[`normal`,`u_c_H25469`]" ><div id="u_c_VWS917"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" :class="[`normal`,`u_c_VWS917`]" ><a id="u_c_GNP830" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light`,`u_c_GNP830`]" @click="u_c_GNP830_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_AI7827"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_AI7827`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"每日\n首充"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"签到\n获豪礼"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往\n充值"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"幸运\n抽奖"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"奖励\n送不停"}],"isShow":true},"zh-CN":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"首储赠礼\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"签到好礼\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往储值\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪华礼盒"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"二重好礼\n"}],"isShow":true},"zh-TW":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"首儲贈禮\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"簽到好禮\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往儲值\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華禮包"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"二重好禮\n"}],"isShow":true},"en-US":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1st Top-up Gift\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Sign-in Gift\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Top Up\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Deluxe Supply Box\n"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Gift\n"}],"isShow":true},"ja-JP":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"初回チャージ \nボーナス\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"サインイン\nボーナス\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"チャージへ\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華記念ギフト"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華ボーナス\n"}],"isShow":true},"ko-KR":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"첫 충전 \n혜택\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"출석\n선물"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"충전하기"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"축제 호화 선물함"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"더블 보너스"}],"isShow":true},"th-TH":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"เติมครั้งแรกมีรางวัล"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"รางวัลเช็คอิน"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"ไปเติมเงิน"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"แพ็กเทศกาลดนตรี"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"รางวัล 2 ชั้น"}],"isShow":true},"vi-VN":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Tặng quà nạp đầu"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Quà điểm danh"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Tới Nạp"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Gói Lễ Hội Âm Nhạc"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":" Quà Thêm"}],"isShow":true},"de-DE":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1. Auflade-Geschenk\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Anmeldeg-\neschenk\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Aufladen\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Deluxe-Versorgungsbox"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus-Geschenk\n"}],"isShow":true},"fr-FR":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau de 1ère de Recharge\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau de Connexion\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recharge\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Boîte d'approvisionnement Deluxe"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau Bonus\n"}],"isShow":true},"es-ES":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de la 1.a recarga\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de registro"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recargar"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pacchetto Festival Musicale"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de bonificación"}],"isShow":true},"pt-PT":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1o presente de recarga\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Presente de login\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recarregar\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Muziekfestival Pakket\n"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Presente Bônus\n"}],"isShow":true},"it-IT":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1mo Regalo Ricarica"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo Iscrizione"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ricarica\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pakiet Festiwalu Muzycznego\n"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo Bonus\n"}],"isShow":true},"tr-TR":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1. Yükleme Hediyesi\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Giri? Hediyesi\n"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Yükleme\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pacote Festival de Música\n"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Hediye\n"}],"isShow":true},"pl-PL":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent 1wszego doładowania"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent logowani"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Doładowanie\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Набор музыкального фестиваля"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent bonusu"}],"isShow":true},"id-ID":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Hadiah Top Up Perdana"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Hadiah Sign-In"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pergi Top up"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Paket Festival Musik"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Hadiah"}],"isShow":true},"ar-SA":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدية الشحن الأول"},{"pic":"","block":"u_c_PU3219","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدية تسجيل الحضور"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"التوجه للشحن"},{"pic":"","block":"u_c_JDH534","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"باقة مهرجان الموسيقى"},{"pic":"","block":"u_c_699X21","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدايا مضاعفة"}],"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面导航';

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = utils.getStoreLinkWithCidScid({
        link: item.link,
        paramsObj: {
          language: curLang,
          gameId: pageData.gameId,
        },
        pageId: pageData.pageId,
      })
    }
  })
}

init()
// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};

let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download"].includes(item.block)) {
      let _ele = document.getElementById(item.block)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
});
      // 自定义元素GNP830的click事件
      const u_c_GNP830_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download"].includes(block)) {
  if (block === "pay") {
    bridge.open(pageData.storeLink);
    return;
  }
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.default{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.default{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.default{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-CN{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.zh-CN{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.zh-CN{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.zh-CN{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-TW{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.zh-TW{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.zh-TW{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.zh-TW{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.en-US{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.en-US{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.en-US{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.en-US{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.ja-JP{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.ja-JP{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.ja-JP{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.ja-JP{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.ko-KR{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.ko-KR{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.ko-KR{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.ko-KR{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.th-TH{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.th-TH{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.th-TH{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.th-TH{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.vi-VN{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.vi-VN{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.vi-VN{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.vi-VN{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.de-DE{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.de-DE{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.de-DE{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.de-DE{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.fr-FR{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.fr-FR{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.fr-FR{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.fr-FR{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.es-ES{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.es-ES{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.es-ES{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.es-ES{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.pt-PT{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.pt-PT{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.pt-PT{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.pt-PT{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.it-IT{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.it-IT{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.it-IT{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.it-IT{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.tr-TR{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.tr-TR{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.tr-TR{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.tr-TR{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.pl-PL{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.pl-PL{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.pl-PL{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.pl-PL{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.id-ID{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.id-ID{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.id-ID{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.id-ID{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.ar-SA{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.ar-SA{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.ar-SA{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742185850443-23.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.ar-SA{
.u_c_AI7827.normal{
position:relative;
font-size:1.20vw;
color:#27313d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
